import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export enum RxOrderEntryAction {
  HAS_PRESCRIBE_PRIVS = "has_prescribe_privs",
  OTC_ALLOWED = "otc_allowed",
}

type RxOrderEntryActions = {
  hasPrescribePrivs: boolean;
  otcAllowed: boolean;
};

interface RxOrderEntryActionItem {
  action: RxOrderEntryAction;
  available: boolean;
}

interface RxOrderEntryActionsResponse {
  availableActions: RxOrderEntryActionItem[];
}

export const useRxOrderEntryActions = ({
  patientId,
}: {
  patientId: string;
}) => {
  return useApi<RxOrderEntryActionsResponse, RxOrderEntryActions>({
    queryOptions: {
      queryKey: QueryKeys.Patient.Chart.Prescriptions.ORDER_ENTRY_ACTIONS({
        patientId,
      }),
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/rx/prescriptions/available-actions",
          {
            params: {
              patientId,
            },
          },
        );
        return response.data;
      },
      select: (data) => {
        const actions = data.availableActions.reduce((acc, item) => {
          if (item.action === RxOrderEntryAction.HAS_PRESCRIBE_PRIVS) {
            acc.hasPrescribePrivs = item.available;
          }
          if (item.action === RxOrderEntryAction.OTC_ALLOWED) {
            acc.otcAllowed = item.available;
          }
          return acc;
        }, {} as RxOrderEntryActions);
        return actions;
      },
    },
  });
};
